import React, {Component} from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import Select from "@material-ui/core/Select";
import MenuItem from '@material-ui/core/MenuItem';
import {getCookie, setCookie} from "../../helpers/cookie";
import {getTranslation} from "../../helpers/get-translation";
import {getNewTranslationFile} from "../../helpers/php";

const styles = theme => ({
	root:{
		transition:' background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
		"&:hover":{
			backgroundColor: 'rgba(0, 0, 0, 0.08)',

		}
	},
	image: {
		height: "40px",
		width: "40px",
		verticalAlign: 'middle',
		marginRight: '16px',
		borderRadius: "25px"
	},
	select: {
		width: "100%",
		'& div:focus':{
			background: 'none'
		},
	},
	icon: {
		display: 'none',
	},
	arrow: {
		height: '20px',
		position: 'absolute',
		right:'15px',
		marginRight: "15px"
	},
});

const supportedLanguages = getTranslation("settings_language_object")
console.log("supportedLanguages", supportedLanguages)
class SettingsOptionLanguageSelect extends Component {
	constructor(props) {
		super(props);

		const currentLanguageCode = this.getGameLanguage() || "en";
		this.state = {
			currentLanguageCode
		};
	}

	getGameLanguage = () => {
		const language = getCookie("gameLanguage") || getTranslation("language");

		return language
	};

	changeLang = ({ target: { value } }) => {
		//TODO Tylko jeśli język się zmienił
		if(value === this.state.currentLanguageCode){
			return
		}

		setCookie("gameLanguage", value, 20*365);
		const { addLoadingScreen, removeLoadingScreen } = this.props;
		addLoadingScreen("loading_language");
		getNewTranslationFile(function(){
			removeLoadingScreen("loading_language");
		});
		this.setState({ currentLanguageCode: value });
	};

	renderLanguageItems = (languages, classes) => {
		return languages.map(language => {
			const code = language["language_code"];
			const name = language["language_name"];
			const link = language["language_icon"];
			return (
				<MenuItem value={code} key={`lang-${code}`}>
					<img
						className={classes.image}
						src={link}
						alt={name}
					/>
					{name}
				</MenuItem>
			)
			})
	};

	render() {
		const { classes, isLast } = this.props;
		const { currentLanguageCode } = this.state;

		return (
			<div>
				<ListItem button={false} className={classes.root}>
					<Select
						value={currentLanguageCode}
						onChange={this.changeLang}
						className={classes.select}
						disableUnderline={true}
						inputProps={{
							classes: {
								icon: classes.icon,
							},
						}}
						// IconComponent="static/images/settings-screen/settings_next_button.png"
					>
						{this.renderLanguageItems(supportedLanguages, classes)}
					</Select>
					<img className={classes.arrow} src={getTranslation("image_settings_arrow_button")} alt="Next arrow"/>
					{/*<img className={classes.arrow} src="static/images/settings-screen/settings_next_button.png" alt="Next arrow"/>*/}
				</ListItem>
				{isLast || <Divider variant="inset" />}
			</div>
		);
	}
}

SettingsOptionLanguageSelect.propTypes = {
	isLast: PropTypes.bool,

	classes: PropTypes.shape({
		image: PropTypes.string.isRequired,
		select: PropTypes.string.isRequired
	}).isRequired,

	addLoadingScreen: PropTypes.func.isRequired,
	removeLoadingScreen: PropTypes.func.isRequired
};

export default withStyles(styles)(SettingsOptionLanguageSelect);